import { useEffect } from "react";
import Aos from "aos";

import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/footer";
import Hero from "./components/UI/Hero";
import Service from "./components/UI/Service";
import Portofolio from "./components/UI/Portofolio";
import Contact from "./components/UI/Contact";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Service />
        <Portofolio />
        <Contact />
      </main>

      <Footer />
    </>
  );
}

export default App;
